<template>
  <div>
    <b-card bg-variant="light" class="mb-3 px-2 pt-2 pb-0" no-body>
      <div class="d-flex">
        <b-form class="flex-grow-1">
          <b-container fluid>
            <b-row>
              <b-col cols="12" xl="5">
                <b-form-group
                  label="Round Name"
                  label-for="rName"
                  v-bind:label-size="formSize"
                  description="Display name for the round."
                >
                  <b-form-input
                    id="rName"
                    v-model="round.name"
                    v-bind:size="formSize"
                    trim
                    lazy
                    @change="checkValidity"
                    autofocus
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="3">
                <b-form-group
                  label="Maximum Score"
                  label-for="rScore"
                  v-bind:label-size="formSize"
                  description="Minimum score is always 0."
                >
                  <b-form-input
                    id="rScore"
                    v-model="round.score_max"
                    v-bind:size="formSize"
                    type="number"
                    min="0"
                    max="1000"
                    lazy
                    @change="checkValidity"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="3">
                <b-form-group
                  label="Half points"
                  label-for="rScore"
                  v-bind:label-size="formSize"
                  description="Quizzers can score ½ points when allowed."
                >
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="round.allow_half_points"
                    v-bind:size="formSize"
                    name="checkbox-1"
                    v-bind:value="1"
                    v-bind:unchecked-value="0"
                    button
                    class="w-100"
                  >
                    <span v-if="round.allow_half_points === 1">Allowed</span>
                    <span v-else>Disabled</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
        <div>
          <TopquizTippy placement="left" noHeader="true">
            <template v-slot:trigger>
              <b-icon-trash @click="deleteRound" class="tq-hover-a" />
            </template>
            <p>Delete this round.</p>
          </TopquizTippy>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import TopquizTippy from "@/components/TopquizTippy";

export default {
  name: "NewQuizPageRoundsItem",
  props: ["round"],
  components: {
    TopquizTippy
  },
  data() {
    return {
      formSize: "sm"
    };
  },
  methods: {
    deleteRound() {
      this.$emit("delete", this.round);
    },
    checkValidity() {
      var valid = true;
      if (this.round.name.length == 0) {
        valid = false;
      }

      if (this.round.score_max < 0 || this.round.score_max > 1000) {
        valid = false;
      }

      this.round.valid = valid;
      this.$emit("validity", valid);
    }
  }
};
</script>
